import React, { useEffect } from "react";
import JobListing from "./pages/JobListing";

function Job(props) {
    const { setActive } = props;
    useEffect(() => {
      //setActive(3);
    }, []);

    return <JobListing />
};

export default Job;